import { Question } from '../types';

const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'DC', label: 'District of Columbia' }
];

export const questions: Question[] = [
  {
    id: 'state',
    title: 'Location',
    question: 'Which state are you located in?',
    options: US_STATES
  },
  {
    id: 'organizationType',
    title: 'Organization Type',
    question: 'What type of organization are you?',
    options: [
      { value: 'nonprofit', label: 'Non-profit (501c3)' },
      { value: 'smallBusiness', label: 'Small Business' },
      { value: 'individual', label: 'Individual' },
      { value: 'government', label: 'Government Entity' }
    ]
  },
  {
    id: 'demographics',
    title: 'Business Demographics',
    question: 'Select all that apply to your business ownership:',
    multiSelect: true,
    options: [
      { value: 'minority', label: 'Minority-Owned Business' },
      { value: 'women', label: 'Women-Owned Business' },
      { value: 'veteran', label: 'Veteran-Owned Business' },
      { value: 'lgbtq', label: 'LGBTQ+-Owned Business' },
      { value: 'disability', label: 'Disability-Owned Business' },
      { value: 'none', label: 'None of the above' }
    ]
  },
  {
    id: 'primaryFocus',
    title: 'Primary Focus',
    question: 'What is your primary area of focus?',
    options: [
      { value: 'arts', label: 'Arts & Culture' },
      { value: 'education', label: 'Education' },
      { value: 'technology', label: 'Technology' },
      { value: 'environmental', label: 'Environmental' },
      { value: 'health', label: 'Health & Wellness' },
      { value: 'social', label: 'Social Services' }
    ]
  },
  {
    id: 'grantAmount',
    title: 'Grant Amount',
    question: 'What grant amount are you seeking? (Select all that apply)',
    multiSelect: true,
    options: [
      { value: 'under10k', label: 'Under $10,000' },
      { value: '10kTo50k', label: '$10,000 - $50,000' },
      { value: '50kTo100k', label: '$50,000 - $100,000' },
      { value: 'over100k', label: 'Over $100,000' }
    ]
  }
];